import { render } from "./EditDeleteMaterial.vue?vue&type=template&id=7df0886a"
import script from "./EditDeleteMaterial.vue?vue&type=script&lang=js"
export * from "./EditDeleteMaterial.vue?vue&type=script&lang=js"

import "./EditDeleteMaterial.vue?vue&type=style&index=0&id=7df0886a&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__